export default {
  en: {
    comparativeAnalysisPage: {
      unknown: "Unknown",
      exportPdf: "Export PDF",
      votesByRegion: "Votes by Region",
      totalVotes: "Total Votes",
      voteDistribution: "Vote Distribution",
      submissions: "Submissions",
      votes: "Votes",
      selected: "Selected",
      resultsCount: "{{count}} results",
      votesCount: "{{n}} votes",
      verifiedCount: "{{count}} verified",
      pendingCount: "{{count}} pending",
      disputedCount: "{{count}} disputed",
      coveragePct: "{{count}}% coverage",
      divisionsInRegion: "{{count}} divisions in this region",
      results: "Results",
      votesCast: "Votes Cast",
      validVotes: "Valid Votes",
      verified: "Verified",
      noDivisionData: "No division data available for this region",
      submissionsTooltip: "{{hour}}:00 - {{count}} submissions"
    }
  },
  fr: {
    comparativeAnalysisPage: {
      unknown: "Inconnu",
      exportPdf: "Exporter en PDF",
      votesByRegion: "Votes par région",
      totalVotes: "Total des votes",
      voteDistribution: "Répartition des votes",
      submissions: "Soumissions",
      votes: "Votes",
      selected: "Sélectionné",
      resultsCount: "{{count}} résultats",
      votesCount: "{{n}} votes",
      verifiedCount: "{{count}} vérifiés",
      pendingCount: "{{count}} en attente",
      disputedCount: "{{count}} contestés",
      coveragePct: "{{count}} % de couverture",
      divisionsInRegion: "{{count}} départements dans cette région",
      results: "Résultats",
      votesCast: "Votes exprimés",
      validVotes: "Votes valides",
      verified: "Vérifiés",
      noDivisionData: "Aucune donnée départementale disponible pour cette région",
      submissionsTooltip: "{{hour}}:00 - {{count}} soumissions"
    }
  }
};
